module.exports = __webpack_public_path__ + "static/media/chatServ.7047f639.png";